import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import '../../../../styles/scss/style.css';

//Components
import TextHeadingOne from '../../atoms/TextHeadingOne';
import TextParagraph from '../../atoms/TextParagraph';
import FormButton from '../../atoms/FormButton';
import Modal from '../Modal';
import { ROOT_URL } from '../../../config/global.js';

//Returning the component
class FormDeleteBot extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentBot: {}
		}
		
		this.deleteBotHandler = this.deleteBotHandler.bind(this);
	}
	deleteBotHandler(e) {
		e.preventDefault();

		// Adding loading state to store
		this.props.loading(true);

		const deleteBotRequest = axios({
            method: 'delete',
            url: `${ROOT_URL}/api/bots/${this.state.currentBot._id}`
        });

        deleteBotRequest.then( (res) => {
			// Adding loading state to store
			this.props.loading(false);
			
			// Updating the store with the current bots (after deletion)
			this.props.fetchBots();
        });
	}
	componentWillReceiveProps(nextProps) {
		this.setState({ currentBot: nextProps.selectedBot.selectedBot });
	}
	render() {
		return (
			<Modal modalClass={this.props.modalClass} onClick={this.props.onClickCancel}>
				<form className={`form formDeleteBot ${this.props.formWrapperClassType}`}>
					<TextHeadingOne text="Delete bot" />
					<TextParagraph text="Are you sure you want to delete this bot?" />
					<div className="formDeleteBot__infoBox">
						<div className="formDeleteBot__info">
							<TextParagraph classType="formDeleteBot__data" text="Bot name:" />
							<TextParagraph text={this.state.currentBot ? this.state.currentBot.name : ''} />
						</div>
					</div>
					<div className="btnRow">
					<FormButton text="Delete bot" onClick={(e) => this.deleteBotHandler(e)} />
					<FormButton text="Cancel" onClick={this.props.onClickCancel} />
					</div>
				</form>
			</Modal>
		)
	}
}

//Making sure that it has a text property when it's declared
FormDeleteBot.propTypes = {
	sectionType: PropTypes.string,
	TextHeadingTwoText: PropTypes.string,
	paragraphText: PropTypes.string,
	buttonText: PropTypes.string
}

export default FormDeleteBot;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormDeleteBot/FormDeleteBot.jsx